import Index from './components/Index';
import Iframe from './components/Iframe';

export const routes = [
  {
    path: '',
    name: 'start',
    components: {
      default: Index
    }
  },
  { path: '/konfigurator', name: 'konfigurator', component: Index },
  { path: '/hausnotruf', name: 'hausnotruf', component: Index },
  { path: '/iframe', name: 'iframe', component: Iframe },
  { path: '/*', name: 'default', component: Index }
];



// WEBPACK FOOTER //
// ./src/routes.js